import { SHOW_SELECTED_URL_PARAM } from '@/config/constants';

import { FILTER_KEYS, NEW_DATA_URL_PARAM } from '../constants';
import type { FilterState } from '../types/filter.types';

export function getEmptyFilterState(): FilterState {
  return {
    only: null,
    [SHOW_SELECTED_URL_PARAM]: false,
    [NEW_DATA_URL_PARAM]: false,
    search: null,
    code: null,
    [FILTER_KEYS.COMMODITY]: [],
    [FILTER_KEYS.TRADING_HUB]: [],
    [FILTER_KEYS.DELIVERY_BASIS]: [],
    [FILTER_KEYS.PRICING_BASIS]: [],
    [FILTER_KEYS.UNITS]: [],
    [FILTER_KEYS.CURRENCY]: [],
    [FILTER_KEYS.FREQUENCY]: [],
    [FILTER_KEYS.INDEX_MODULE]: []
  };
}
